import { render, staticRenderFns } from "./DeleteTransactionsPanelHeader.vue?vue&type=template&id=35bad0c4&scoped=true&"
import script from "./DeleteTransactionsPanelHeader.vue?vue&type=script&lang=ts&"
export * from "./DeleteTransactionsPanelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTransactionsPanelHeader.vue?vue&type=style&index=0&id=35bad0c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bad0c4",
  null
  
)

export default component.exports